import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readAllByEmisor: emisor =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!) {
            CostoFijo {
              readAllByEmisor(emisor: $emisor) {
                _id
                nombre
                descripcion
                cuentaContable
                costoUnitarioTotal
                unidadMedida {
                  id
                }
                codigoMoneda {
                  id
                }
                codigo
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.CostoFijo.readAllByEmisor),

  create: input =>
    api
      .send({
        query: gql`
          mutation CREATE($input: CostoFijoInput!) {
            CostoFijo {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.CostoFijo.create),

  delete: (_idEmisor, input) =>
    api
      .send({
        query: gql`
          mutation delete($_idEmisor: ID!, $input: [ID!]!) {
            CostoFijo {
              delete(_idEmisor: $_idEmisor, input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { _idEmisor, input }
      })
      .then(result => result.data.data.CostoFijo.delete)
}
